import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Container, Card, CardBody, Table } from 'reactstrap';
import common from 'constants/common';
import DownloadRoundedIcon from 'components/atoms/icons/downloadRoundedIcon';
import Pagination from 'components/molecules/pagination';
import withLoader from 'components/organisms/withLoader';
import ActivityRow from 'components/templates/rpm/practice/interactiveReport/activityRow';
import Sorting from 'components/templates/rpm/practice/interactiveReport/sorting';
import { showResult } from 'utils';

const headings = [
  'Patient Name',
  'MRN',
  'Contact',
  'Insurance Plan Provider',
  'Insurance Plan Number',
  'Physician',
  'Number Of Reviews',
  'Total Review Time',
  'Numbers Of Comments',
  'Total Comment Time',
  'Numbers Of Manuals',
  'Total Manual Time',
  'Numbers Of Calls',
  'Total Call Time',
  'Last Call Time',
  'Range',
  'Total Time',
];

const Activity = () => {
  const {
    interactiveTime: interactiveTimeReport,
    page,
    itemsPerPage: ITEMS_PER_PAGE,
    totalCount: totalItems,
    dates: interactiveTimeDates,
  } = useSelector((state) => state.interactiveTime);
  const {
    getInteractiveReport: reportLoading,
    getInteractiveCsvReport: csvLoading,
  } = useSelector((state) => state.loading.effects.interactiveTime);

  const {
    interactiveTime: { setPageInteractiveTime, getInteractiveCsvReport },
  } = useDispatch();

  const setPage = (pageOffset) => {
    setPageInteractiveTime({ pageOffset });
  };

  const sendReport = async () => {
    const { error } = await getInteractiveCsvReport();
    return showResult(error, common.submitSuccessTypes.sendReport);
  };

  return (
    <Container>
      <div className="activity-report">
        <Card className="card-border">
          <CardBody className="card-outer">
            <div className="performance-review__header">
              <div className="activity-header">
                <h3>Report: Interactive Time</h3>
              </div>
              <div className="performance-review__header-icon">
                {withLoader(
                  interactiveTimeDates.length < 0 || csvLoading,
                  <button onClick={sendReport}>
                    <DownloadRoundedIcon className="performance-review__header-icon-svg" />
                    <br />
                    <span>Download</span>
                  </button>,
                )}
              </div>
            </div>
            <div className="activity-body">
              <div className="sort-row">
                <Sorting />
              </div>
              <div className="table-sticky-header interactive-time-table">
                {withLoader(
                  reportLoading,
                  <Table borderless cellSpacing="0" cellPadding="0">
                    <thead>
                      <tr>
                        {headings &&
                          headings.map((heading, i) => (
                            <th
                              className="table-status-column"
                              key={`table-heading-${i}`}
                            >
                              <div className="sort-div">{heading}</div>
                            </th>
                          ))}
                      </tr>
                    </thead>
                    <tbody>
                      {interactiveTimeReport.map((activityRow, i) => (
                        <ActivityRow
                          key={`table-row-${i}`}
                          activity={activityRow}
                        />
                      ))}
                    </tbody>
                  </Table>,
                )}
              </div>
              <div className="billing-table-button-pagination flex-row-reverse">
                <Pagination
                  title=""
                  page={page}
                  pageTotal={interactiveTimeReport.length}
                  itemsPerPage={ITEMS_PER_PAGE}
                  total={totalItems}
                  handlePrevClick={() => setPage(-1)}
                  handleNextClick={() => setPage(+1)}
                  handleFirstClick={() => setPage(-(page - 1))}
                  handleLastClick={() =>
                    setPage(Math.ceil(totalItems / ITEMS_PER_PAGE))
                  }
                />
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    </Container>
  );
};

export default Activity;
